<template>
  <v-app>
    <AllowedUserAuthContainer :page-types="['client']">
      <SessionShareContainer />
      <master-client-header />
      <v-main>
        <div
          class="d-flex justify-space-between"
          style="position: relative; margin-top: 70px"
        >
          <template>
            <router-view name="subSidebar" />
            <router-view />
          </template>
        </div>
        <slot />
      </v-main>
    </AllowedUserAuthContainer>
    <toaster />
    <loading-overlay />
    <SystemInformationConfirmDialog></SystemInformationConfirmDialog>
  </v-app>
</template>

<script>
import MasterClientHeader from '@/components/masterClientLayout/Header'
import Toaster from '@/components/commons/Toaster'
import LoadingOverlay from '@/components/commons/LoadingOverlay'
import { mapState } from 'vuex'
import AllowedUserAuthContainer from '../../src/container/shared/AllowedUserAuthContainer'
import SessionShareContainer from '../../src/container/shared/SessionShare'
import SystemInformationConfirmDialog from '../../src/container/shared/SystemInformationDetailDialogs/confirm.vue'

export default {
  name: 'App',
  components: {
    MasterClientHeader,
    AllowedUserAuthContainer,
    SessionShareContainer,
    Toaster,
    LoadingOverlay,
    SystemInformationConfirmDialog
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => {
        return state.UserAuthStore.currentUserAuth
      }
    })
  }
}
</script>
